import main from "./main";
import simbol from "./simbol";

export default{
    ...main,
    ...simbol
}